import { Container } from 'bitmovin-player-ui';
import { createGoBackLiveButton, createWatchFromStartButton } from './buttons';
import { createAdButton } from './adbutton';
import { createAdLabel } from './adlabel';
import { NpoPlayerUIVariants } from '../../types/interfaces';
export function createCTABar(player, npoplayer, variant) {
    const barComponents = [];
    if (variant === NpoPlayerUIVariants.DEFAULT) {
        const goBackLiveButton = createGoBackLiveButton(player);
        const watchFromStartButton = createWatchFromStartButton(player, npoplayer);
        barComponents.push(watchFromStartButton, goBackLiveButton);
    }
    if (variant === NpoPlayerUIVariants.AD) {
        const adLabel = createAdLabel(npoplayer);
        const adButton = createAdButton(npoplayer);
        barComponents.push(adLabel, adButton);
        adLabel.hide();
    }
    return new Container({
        components: barComponents,
        cssClasses: ['controlbar-textbuttons']
    });
}
